import type { IExtractRouteParamMap, IRouteTranslation } from "../../../types";
import {
  concatBreadcrumbs,
  createBreadcrumbObject,
  createPaths,
} from "../../../utils";

import {
  courseChapterBreadcrumbs,
  courseChaptersRoutesObj,
} from "@routes/facultyMember/courseManagement/courseChapter/path";

// Base route constant
const baseRoute = `${courseChaptersRoutesObj.view}/exam` as const;

// * Route configuration object for courseChapterExams-related paths.
// ! This object is `readonly` to ensure route parameters are extracted properly.
export const courseChapterExamsRoutesObj = {
  create: `${baseRoute}/create`,
  view: `${baseRoute}/view/:examId`,
  edit: `${baseRoute}/edit/:examId`,
} as const;

// ! these are breadcrumbs translation not page title
const courseChapterExamsRouteTranslation: IRouteTranslation<
  typeof courseChapterExamsRoutesObj
> = {
  create: "addExam",
  edit: "editExam",
  view: "viewExam",
};

// * Extracts the route parameters for the course-chapter-exams route configuration.
export type ICourseChapterExamsRouteParams = IExtractRouteParamMap<
  typeof courseChapterExamsRoutesObj
>;

// * Path functions for the course-chapter-exams routes.
export const courseChapterExamsPath = createPaths<
  typeof courseChapterExamsRoutesObj,
  ICourseChapterExamsRouteParams
>(courseChapterExamsRoutesObj);

// * Breadcrumbs {translation and route} for the course chapter exams routes
const thisCourseChapterExamsBreadcrumbs = createBreadcrumbObject<
  typeof courseChapterExamsRoutesObj
>(courseChapterExamsRoutesObj, courseChapterExamsRouteTranslation);

export const courseChapterExamsBreadcrumbs = concatBreadcrumbs<
  typeof courseChapterExamsRoutesObj
>(courseChapterBreadcrumbs.view, thisCourseChapterExamsBreadcrumbs);
